import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const TableHeader = styled('header')`
  margin: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x2spacePx}px;

  ${media.lgUp`
    margin-left: 0;
    margin-right: 0;
  `}
`;
